import { useEffect, useMemo, useState } from 'react';
import { add, set } from 'date-fns';
import faker from 'faker';
import { shuffle } from 'lodash';

import { useFleets } from 'Hooks';
import { DeliveryOptions } from 'Types';

const wait = (time: number) => new Promise((res) => setTimeout(res, time));

const deliveryTypes = [
  'Same day delivery - get it in 3 hours!',
  'Next day delivery',
  'Two day delivery',
  'Eco-friendly delivery',
];

const prices = [12, 7, 0, 0];

export function useAvailableDeliveries(): [boolean, DeliveryOptions[]] {
  const fleets = useFleets();
  const [isLoading, setIsLoading] = useState(false);

  const options = useMemo<DeliveryOptions[]>(() => {
    const now = new Date();

    return shuffle(fleets)
      .slice(0, deliveryTypes.length)
      .map((fleet, index) => {
        const date = add(now, { days: index });
        const minHour = faker.random.number({ min: 7, max: 17 });
        const getISODate = (hours: number) => set(date, { hours }).toISOString();

        return {
          fleet,
          text: deliveryTypes[index],
          pickUp: {
            no_earlier_than: getISODate(minHour - 1),
            no_later_than: getISODate(minHour),
          },
          dropOff: {
            no_earlier_than: getISODate(minHour + 1),
            no_later_than: getISODate(minHour + 3),
          },
          scheduled_at: getISODate(minHour),
          price: prices[index],
        };
      });
  }, [fleets]);

  useEffect(() => {
    async function fetchAvailableProviders() {
      setIsLoading(true);
      await wait(faker.random.number({ min: 500, max: 2500 }));
      setIsLoading(false);
    }

    fetchAvailableProviders();
  }, []);

  return [isLoading, options];
}
